import { render, staticRenderFns } from "./DiseaseDiagnosis.vue?vue&type=template&id=33108370&"
import script from "./DiseaseDiagnosis.vue?vue&type=script&lang=js&"
export * from "./DiseaseDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports